import React from "react";

export default function Footer() {

  return (
    <div className="flex flex-col justify-center py-10 md:py-20 w-full items-center font-nunito shadow-xl bg-[#161616] text-white">
      <div className="flex flex-col md:flex-row justify-between w-full md:w-[1100px] px-6">

        {/* Left Section */}
        <div className="mb-10 md:mb-0">
          <div className="flex flex-row items-center mb-6 gap-x-2">
            <h1 className="text-2xl font-bold font-bebas tracking-wider">
              PLAYSET
            </h1>
          </div>
          {/* <p className="text-gray-300 mt-2">🇬🇧 Made in Great Britain</p> */}
          <p className="text-gray-300 mt-2">&copy; Playset 2025—2026</p>
        </div>

        {/* Links */}
        <div className="flex flex-col md:flex-row gap-10 md:gap-24">

          {/* <div>
            <h3 className="text-gray-400 font-semibold mb-2">BLOG</h3>
            <ul className="flex flex-col text-gray-300 space-y-1">
              <a href="/blog/beginners-guide-to-teaching-english-as-a-second-language-esl">A Beginner's Guide to ESL</a>
            </ul>
          </div> */}

          <div>
            {/* <h3 className="text-gray-400 font-semibold mb-2">LEGAL</h3> */}
            <ul className="flex flex-col text-gray-300 space-y-1">
              <a href="/termsofservice">Terms of Service</a>
              <a href="/privacypolicy">Privacy Policy</a>
            </ul>
          </div>

        </div>

      </div>
    </div>
  );
}
